export default {
	qita: 'その他',
	chengjirenyixuanze: '搭乗者はすでに選択されており、繰り返し選択することはできません',
	dingdanzhuangtai: '受注ステータス',
	daifukuan: '支払い保留中',
	daichupiao: '発券保留中',
	chupiaowancheng: '発券完了',
	quxiao: 'キャンセル',
	yinhangka: '銀行カード',
	dianziqianbao: '電子財布',
	yiwancheng: '完了',
	weiwancheng: '未完了',
	quxiaozhong: 'キャンセル中',
	zhifuzhong: '支払い中',
	chongxinxuanzezhifufangshi: '支払い方法の再選択',
	zhifuweiwancheng: '支払いが完了していません',
	jixuzhifu: '支払いを継続する',
	chongxingoumai: '再購入',
	ninhaiweiwanchengzhifu: '支払いはまだ完了していませんが、支払いを続行しますか？',
	quebaoziliao: 'すべての情報が正確であることを確認してください。',
	lianluorenziliao: '連絡先の情報',
	dianhuahaoma: '電話番号',
	fujiafuwu: 'オプション',
	feixingchangkehaoma: '会員番号',
	dianziyouhuiquan: '電子クーポン',
	meiyoudianziyouhui: '電子クーポンを所持していません',
	wodedaima: 'コードを持っています',
	jiayiri: '日',
	jiaerri: '日',
	xianzaifukuan: '今すぐ支払う',
	zhifuwancheng: '支払い完了',
	cuowuyuanyin: 'エラーの原因',
	zhifucuowu: '支払エラー',
	bizhongbuzhichi: 'この通貨はサポートされていません',
	jinechaochuxianzhi: '限度額を超える金額',
	yudaowenti: '問題にぶつかる',
	qingninzaixindakaideyemian: '新しく開いたページでお支払いください！',
	zhifuwanchengqianqingbuyao: '支払いが完了するまでこのウィンドウを閉じないでください',
	querenzhifu: '支払いの確認',
	xiugai: '編集',
	xiangqing: '詳細',
	chengke: '乗客',
	daililianluoziliao: '代理店の連絡先の情報',
	banlidengji: 'チェックイン',
	chakanguanli: '表示/管理',
	chufa: '出発',
	riqishijian: '日付/時刻',
	yudingcankaobianhao: '予約参照番号',
	chengshijichang: '都市/空港',
	dao: '到',
	daoda: '到着',
	daodashijian: '到着時刻',
	xingcheng: '行程',
	lieyin: '印刷',
	shuikuanfapiao: '税請求書',
	genggaihangbanyaoqiu: 'フライト変更の要件',
	lvxingshijian: '旅行時間',
	xinglie: '手荷物',
	nian: ' 年',
	yue: ' 月',
	geshibuzhengque: 'フォーマットエラー',
	lianxirenxingming: '担当者名',
	tuipiao: 'チケットの払い戻し',
	gaiqian: 'くじを引く',
	querenyaotuipiaoma: 'キャンセルを確認しますか？',
	querenyaogaiqianma: '変更を確認しますか？',
	pingtaifuwufei: 'プラットフォーム・サービス料',
	jishufuwufei: '技術サービス料',
	xuzhifu: '支払いが必要',
	canshucuowu: 'パラメータエラー',
	chupiaoshibaichongxinyuding: '発券に失敗し再予約',
	chupiaoshibaibufentuikuanchenggong: '発券に失敗した部分の返金に成功しました',
	chupiaoshibaituikuanshibai: '発券失敗返金失敗',
	dingdanzhuangtaiyichang: 'オーダーステータス例外',
	shouxufei: '手数料',
	xinglixinxi: '荷物情報',
	xingli: '荷物',
	dingdanxinxi: 'オーダー情報',
	dingdantijiaochenggong: 'オーダーの送信に成功しました',
	qingzhifu: '30分以内にお支払いください。そうしないと、注文はキャンセルされます。',
	kezailiebiaochakan: '注文リストに自分の「注文」を表示できます',
	chakandingdan: 'オーダーの表示',
	ri: '日',
	yiyue: '1月',
	eryue: '2月',
	sanyue: '3月',
	siyue: '4月',
	wuyue: '5月',
	liuyue: '6月',
	qiyue: '7月',
	bayue: '8月',
	jiuyue: '9月',
	shiyue: '10月',
	shiyiyue: '11月',
	shieryue: '12月',
	xuanzefukuanfangshi: '支払い方法を選択する',
	qingyu: '',
	neiwanchengzhifu: 'までにお支払いをお願いします',
	kaxinxi: 'カード情報',
	xinyongkahao: '番号',
	xinyongkayouxiaoqi: '有効期',
	chikarenxingshi: 'カード所持者の姓',
	chikarenmingzi: 'カード所持者の名前',
	youxiang: 'メールボックス',
	dianhua: '電話',
	shengfendiqu: '省/地域',
	chengshi: '都市',
	youbian: '郵便番号住所',
	jiedaodizhi: '住所（通り）',
	zhangdanxinxi: '請求書情報',
	dingdanbianhao: '注文番号:',
	dingdanbizhong: '受注通貨:',
	dingdanjine: 'オーダー金額:',
	guojia: '国家',
	zhuan: '回す',
	ci: '次',
	fen: '分',
	miao: '秒',
};
